import {
  Box,
  createTheme,
  ThemeProvider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./App.css";
import React, { useState } from "react";
import Sidebar from "./Components/Sidebar";
import Index from "./Routes";
import { Main } from "./Config/Style";
import CustomizedSnackbars from "./Components/shared/Toast/ToastContainer";
import Header from "./Components/Header";

const AppContent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);

  return (
    <Box sx={Main.box}>
      <CustomizedSnackbars />
      <Sidebar open={open} setOpen={setOpen} isMobile={isMobile} /> 

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          backgroundColor: "#EDE8F5",
          overflow: "hidden",
        }}
      >
        <Header open={open} setOpen={setOpen} isMobile={isMobile} />
        <Box sx={{ flexGrow: 1, overflowY: "auto", p: 1 }}>
          <Index />
        </Box>
      </Box>
    </Box>
  );
};

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
